import { AppState } from 'src/app/core/core.state'
import { ResourceEffects } from 'src/app/shared/resource-effects'

import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'

import { Sale } from './sale'
import { saleActions } from './sale.actions'
import * as fromSale from './sale.reducer'
import { SaleService } from './sale.service'
import {
  exhaustMap,
  map,
  switchMap,
  take,
  tap,
  withLatestFrom
} from 'rxjs/operators'
import { normalizeToSchema } from '../../shared/normalization/normalization'
import { normalizationActions } from '../../shared/normalization/normalization.actions'
import { persistentUserRoleActions } from '../role/user-role/persistent-user-role/persistent-user-role.actions'
import { of } from 'rxjs'
import { persistentUserRoleSelectors } from '../role/user-role/persistent-user-role/persistent-user-role.selector'

@Injectable()
export class SaleEffects extends ResourceEffects<Sale> {
  fetchIndex = createEffect(() =>
    this.actions$.pipe(
      ofType(saleActions.fetchIndex),
      exhaustMap((action) =>
        this.saleService.getMany(action.params).pipe(
          switchMap(({ data: entities, total }) => [
            saleActions.upsertManyIndex({
              total,
              entities: Object.values(
                normalizeToSchema({ sales: entities })['sales']
              )
            }),
            normalizationActions.upsertMany({
              total,
              entities: normalizeToSchema({ [this.entityFeatureKey]: entities })
            })
          ])
        )
      )
    )
  )

  onSetSelectedUserRole = createEffect(
    () =>
      this.actions$.pipe(
        ofType(persistentUserRoleActions.setSelectedUserRole),
        tap((action) => {
          let userRole: any
          this.store
            .select(persistentUserRoleSelectors.selectSelectedUserRole)
            .pipe(take(1))
            .subscribe((user) => {
              userRole = user
            })
          userRole && this.store.dispatch(saleActions.resetState())
        })
      ),
    { dispatch: false }
  )
  createSeparateSale = createEffect(() =>
    this.actions$.pipe(
      ofType(saleActions.createSeparateSale),
      switchMap(({ saleId, saleItems }) =>
        this.saleService.createSeparateSale({ saleId, saleItems }).pipe(
          map((sales) => {
            if (sales) {
              return normalizationActions.upsertMany({
                entities: normalizeToSchema({
                  sales: sales.data ?? sales
                })
              })
            }
          })
        )
      )
    )
  )
  constructor(
    public actions$: Actions,
    public store: Store<AppState>,
    public saleService: SaleService,
    public router: Router
  ) {
    super(fromSale.FEATURE_NAME, saleService, saleActions, actions$)
  }
}
